export default __webpack_public_path__ + "static/media/no-comments.6dd04cf2.svg";